import { useEffect } from 'react';

import * as keycodes from './key-constants';

export const KEYS = keycodes;

// listeners are a MAP
const listeners = new Map();
const shiftKeyListeners = new Map();

let shouldDebounce: boolean = false;

function allow(): void {
	shouldDebounce = false;
}

function handleKeyDown(e: KeyboardEvent): void {
	// Only listen for keyboard shortcuts when no inputs
	// are selected (if user is typing something, not a shortcut)
	if (e.target !== document.body) {
		// user click button tag, target is button
		const target = e.target as Element;
		if (
			target.tagName.toLowerCase() !== 'button'
			&& !target.parentElement?.classList.contains('info-modal-background') // modals should be treated as a body
			&& target.getAttribute('data-test-id') !== 'virtuoso-scroller' // this is selected whenever you open the ellipse menu from scrollable
		) {
			return;
		}
	}

	if (!shouldDebounce) {
		if (listeners.has(e.keyCode)) {
			listeners.get(e.keyCode)(e);
			shouldDebounce = true;
			setTimeout(allow, 200);
		} else if (shiftKeyListeners.has(e.keyCode)) {
			if (e.shiftKey) {
				shiftKeyListeners.get(e.keyCode)(e);
				shouldDebounce = true;
				setTimeout(allow, 200);
			}
		}
	}
}

let initialized = false;

export function init(): void {
	if (!initialized) {
		window.addEventListener('keydown', handleKeyDown);
		initialized = true;
	}
}

// event.keyCode is deprecated, use event.code
export function addListener(key: number, func: Function, shiftReq?: boolean): void {
	init();
	if (shiftReq) {
		shiftKeyListeners.set(key, func);
	} else {
		listeners.set(key, func);
	}
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function removeListener(key: number, func: Function): void {
	listeners.delete(key);
}

export function removeAllListeners(): void {
	listeners.clear();
}

// can be called as a hook
export function useKey(key: number, func: Function): void {
	useEffect(() => {
		init();
		if (listeners.get(key) !== func) {
			addListener(key, func);
		}

		return () => removeListener(key, func);
	});
}
